webpackJsonp([99415631985094],{

/***/ 1596:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"UpdateStockTransferTemplateInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"isPriority","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"locationId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"templateItems","type":{"kind":"LIST","name":null,"ofType":{"kind":"NON_NULL","name":null,"ofType":{"kind":"INPUT_OBJECT","name":"UpdateStockTransferTemplateItemInput","ofType":null}}}},{"defaultValue":null,"description":null,"name":"toStockLocationId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-update-stock-transfer-template-input-18404e77bb143caa950a.js